import { createContext } from "react";

const ContactFormOtherInfoContext = createContext();

export default ContactFormOtherInfoContext;